module.exports = __webpack_public_path__ + "img/delete.79977525.svg";